import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { GameEvent } from "../../../controller/event/GameEvent";
import gsap from "gsap";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
export class GameCoinWinOverlay extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(GameEvent.COIN_WIN_START, this.start);
    }
    create() {
        super.create();
        this.collection = TitanSpine.createSpine(this, this.landscapeProperties.collectionSpineProperties, this.portraitProperties?.collectionSpineProperties);
        SpineUtil.addNamedEventListener(this.collection, "impact", this.handleCollectionImpact, this, 0);
    }
    start() {
        SpineUtil.play(this.collection, ["0-collection-landscape", "0-collection-portrait"], () => {
            this.dispatchGame(GameEvent.COIN_WIN_COMPLETE);
        });
    }
    handleCollectionImpact() {
        this.dispatchGame(GameEvent.COIN_WIN_UPDATE_TOTAL);
    }
    async blockUntil(event) {
        return new Promise(resolve => {
            this.registerGame(event, () => {
                this.unregisterGame(event);
                resolve();
            });
        });
    }
    async delayFor(timeInSeconds) {
        return new Promise(resolve => {
            gsap.delayedCall(timeInSeconds, resolve);
        });
    }
}
//# sourceMappingURL=GameCoinWinOverlay.js.map